<template>
  <v-container >
    <workflowGrid v-if="edit" @editItem="editItem" />
    <workflowbForm v-else :workflowName="workflowName" @editItem="editItem" />
  </v-container>
</template>

<script>
import workflowGrid from './grid'
import workflowbForm from './form'

export default {
  name: 'Workflow',

  data: () => ({
    edit: true,
    workflowName: '',
    workflowDescription: ''
  }),

  components: {
    workflowGrid,
    workflowbForm
  },

  methods: {
    editItem (boolean, item) {
      this.edit = boolean
      this.workflowName = item?.workflowName
      this.workflowDescription = item?.workflowDescription
    }
  }
}
</script>
